import React from 'react';
import Button from './Button';

const SubmitButton = (props) => <Button type="primary" htmlType="submit" {...props} />;

export default SubmitButton;
